import type React from 'react';
import { redirect } from '@peloton/navigation';
import { toNewSubscriptionsUrl } from './urls';

export const SubscriptionsRedirect: React.FC<React.PropsWithChildren<unknown>> = () => {
  redirect(toNewSubscriptionsUrl());
  return null;
};
